import React, { useRef, useEffect, useState } from 'react';
import paper from 'paper';
import ProgressBar from '../ProgressBar';

export const Melt = ({
  colors = [ 'blue'],
  strokeWidth = 20,
  startingStrokeCounter = 20,
  strokeIncrement = 0.1,
  segments = 100,
  bend = 25,
  documentBackgroundColor = 'white',
  fillColor = 'black',
  barColor = 'rgba(0,0,0,0.45)',
  methodX = x => Math.sin(x),
  methodY = y => Math.cos(y),
  texts = [
    {
      text: 'Sample 1',
      count: 100,
      fontSize: 50,
    },
    {
      text: 'An then 2',
      count: 200,
      fontSize: 100,
    },
    {
      text: 'Finally 3',
      count: 300,
      fontSize: 300,
    }
  ],
  content = {
    justification: 'center',
    fontSize: texts[0].fontSize + 'px',
  }
}) => {
  const canvasRef = useRef(null);
  const barRef = useRef({ index: 0, counter: 0 });
  const [barProgress, setBarProgress] = useState({ index: 0, counter: 0 });

  useEffect(() => {
    paper.setup(canvasRef.current);
    let counter = startingStrokeCounter;

    const curves = [];
    for (let i = 0; i < colors.length; i++) {
      const curve = new paper.Path();
      curve.strokeColor = colors[i];
      curve.strokeWidth = strokeWidth;
      curve.strokeJoin = 'round';

      const radius = 50 + i * 10;

      for (let j = 0; j < segments; j++) {
        const angle = (j / segments) * (Math.PI * 2.1);
        const x = methodX(angle) * radius + paper.view.center.x;
        const y = methodY(angle) * radius + paper.view.center.y;
        curve.add(new paper.Point(x, y));
      }

      curves.push(curve);
    }

    const displayText = new paper.PointText({
      point: [paper.view.size.width/2, paper.view.size.height/2],
      content: texts[0].text,
      ...content,
    });
    displayText.fillColor = fillColor;

    const onMouseMove = (event) => {
      document.body.style.backgroundColor = documentBackgroundColor;

      const mousePoint = event.point;
      counter += strokeIncrement;

      const bar = barRef.current;
      if (bar.index < texts.length - 1) bar.counter += 1;
      if (bar.counter > texts[bar.index].count) {
        bar.index += 1;
        displayText.content = texts[bar.index].text;
        displayText.fontSize = texts[bar.index].fontSize;
      }
      setBarProgress({ index: bar.index, counter: bar.counter });

      for (let i = 0; i < curves.length; i++) {
        const curve = curves[i];
        for (let j = 0; j < curve.segments.length; j++) {
          curve.strokeWidth = counter;
          const segment = curve.segments[j];
          const distance = segment.point.getDistance(mousePoint);
          const bendFactor = bend / (distance + 1);
          const direction = segment.point.subtract(mousePoint).normalize();
          segment.point = segment.point.add(direction.multiply(bendFactor));
        }
      }
    };

    paper.view.on('mousemove', onMouseMove);

    return () => {
      paper.view.off('mousemove', onMouseMove);
      paper.project.clear();
    };
  }, []);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <canvas ref={canvasRef} style={{ width: '100%', height: '100%' }} />
      <ProgressBar
        texts={texts}
        index={barProgress.index}
        counter={barProgress.counter}
        color={barColor}
      />
    </div>
  );
};

export default Melt;
